// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBodrnacGiOMk2BnfoOXeuEhpLAtZcz8IA",
    authDomain: "react-new-ecommerce.firebaseapp.com",
    projectId: "react-new-ecommerce",
    storageBucket: "react-new-ecommerce.appspot.com",
    messagingSenderId: "852636347241",
    appId: "1:852636347241:web:f5db76f7a9ad155c076bf8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);